module.exports = __webpack_public_path__ + "static/media/454A9286.9726f6b9.jpg";